import React from 'react';

export default function Privacy() {
  return (
    <main className="page-transition min-h-screen flex justify-center items-center">
      <div className="max-w-xl text-center">
        <h1 className="text-xl uppercase tracking-widest mb-8">Privacy Policy</h1>
        <p className="text-gray-500 text-sm leading-loose">
           We respect your privacy. Any information collected (like your email for the newsletter) is used solely for that purpose and never shared with third parties.
        </p>
      </div>
    </main>
  );
}
